import React, { useState, useEffect } from 'react';
import { api } from '../../frontend/components/api';
import VoicePluginButton from './VoicePluginButton';
import VoiceChatWidget from './VoiceChatWidget';
import VoiceChatPluginPopup from './VoiceChatPluginPopup';
import './VoicePluginWidget.scss';

export default function VoicePluginWidget({ token, fullscreen }) {
  const [voiceConfiguration, setVoiceConfiguration] = useState(null);
  const [showVoiceChatWidget, setShowVoiceChatWidget] = useState(false);

  const getVoiceConfiguration = async () => {
    try {
      const response = await api.getVoiceConfigurationForToken(token);
      setVoiceConfiguration(response);
    } catch (error) {
      console.error('Error fetching voice configuration:', error);
    }
  };

  useEffect(() => {
    getVoiceConfiguration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (fullscreen) {
    return (
      <div className="prospera-full-screen-voice-chat-plugin-container">
        <VoiceChatWidget voiceConfiguration={voiceConfiguration} />
      </div>
    );
  } else {
    return (
      <>
        {voiceConfiguration ? (
          <VoicePluginButton
            voiceConfiguration={voiceConfiguration}
            onClick={() => setShowVoiceChatWidget(!showVoiceChatWidget)}
          />
        ) : null}
        {showVoiceChatWidget ? (
          <VoiceChatPluginPopup voiceConfiguration={voiceConfiguration} />
        ) : null}
      </>
    );
  }
}
